export const prepareContent = (content) => {
	const searchPattern = /<section><h2 id="([A-Za-z-]+)"/g;
	const replacePattern = '<section id="$1"><h2';
	return content?.replace(searchPattern, replacePattern);
};
